import {
  type RequestBillingPortalUrlReq,
  type RequestBillingPortalUrlRes,
} from '../entity/api/routes/billing';
import { type EndTrialReq, type EndTrialRes } from '../entity/api/routes/subscription';
import { apiRequest } from './request';

export function requestBillingPortalUrl(
  id: RequestBillingPortalUrlReq['params']['organizationId']
) {
  return apiRequest<RequestBillingPortalUrlRes>(
    `/subscription/organization/${id}/billing-portal`,
    'GET',
    true
  );
}

export function endSubscriptionTrial(id: EndTrialReq['params']['organizationId']) {
  return apiRequest<EndTrialRes>(`/subscription/organization/${id}/end-trial`, 'POST', true);
}
